import { ObstetricalResourcesAnxietyScreeningSection } from "@/Patient/Components/MedicalNote/Obstetric/Form/Common/Page/Resources/Subcomponent/ObstetricalResourcesAnxietyScreeningSection";
import { ObstetricalResourcesDepressionScreeningSection } from "@/Patient/Components/MedicalNote/Obstetric/Form/Common/Page/Resources/Subcomponent/ObstetricalResourcesDepressionScreeningSection";
import { ObstetricalResourcesTAceScreeningSection } from "@/Patient/Components/MedicalNote/Obstetric/Form/Common/Page/Resources/Subcomponent/ObstetricalResourcesTAceScreeningSection";
import { OntarioObstetricalFilePage, OntarioObstetricalFilePageState } from "@/Patient/Components/MedicalNote/Obstetric/Form/Ontario/OntarioObstetricalFilePage";
import { OntarioObstetricalFileForm } from "@/Patient/Models/ObstetricalFile/Ontario/OntarioObstetricalFileForm";
import { OntarioObstetricalFileResourcesEdinburghScale } from "./Subcomponent/OntarioObstetricalFileResourcesEdinburghScale";

class OntarioObstetricalFileResources extends OntarioObstetricalFilePage<OntarioObstetricalFilePageState> {
    private readonly componentId = "ontario-obstetrical-file-resources";

    protected renderPageContent(): JSX.Element {
        return (
            <div id={this.componentId} className="inner-border">
                <div className="section border border-bottom">
                    <div className="row row-form">
                        {this.renderLastName("col-md-3")}
                        {this.renderFirstName("col-md-3")}
                    </div>
                </div>
                <div className="section border border-bottom">
                    <div className="row">
                        <div className="col-md-6">
                            <ObstetricalResourcesAnxietyScreeningSection<OntarioObstetricalFileForm>
                                {...this.getSubcomponentBaseProps()}
                                model={this.props.form.Resources.AnxietyScreening}
                                mutateAnxietyScreeningStateWithFormUpdate={(mutation, then) => this.mutateModelStateWithFormUpdate(s => mutation(s.form.Resources.AnxietyScreening), then)}
                                encounterId={this.props.encounter.Id}
                                patientContactFacetId={this.props.patient.PatientResponse.ContactFacet_id}
                                consultationDate={this.props.encounter.ConsultationDate}
                            />
                        </div>
                        <div className="col-md-6">
                            <ObstetricalResourcesDepressionScreeningSection<OntarioObstetricalFileForm>
                                {...this.getSubcomponentBaseProps()}
                                model={this.props.form.Resources.DepressionScreening}
                                mutateModel={mutation => this.mutateModelStateWithFormUpdate(s => mutation(s.form.Resources.DepressionScreening))}
                            />
                        </div>
                    </div>
                </div>
                <ObstetricalResourcesTAceScreeningSection<OntarioObstetricalFileForm>
                    {...this.getSubcomponentBaseProps()}
                    model={this.state.form.Resources.TaceScreening}
                    mutateTAceScreeningStateWithFormUpdate={mutation => this.mutateModelStateWithFormUpdate(s => mutation(s.form.Resources.TaceScreening))}
                    className="section border border-bottom"
                />
                <OntarioObstetricalFileResourcesEdinburghScale {...this.getSubcomponentBaseProps()} />
            </div>
        );
    }
}

export { OntarioObstetricalFileResources };
